import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, ConfirmationService } from 'primeng/api';
import { FileUploadEvent } from 'primeng/fileupload';
import { Media } from 'src/app/modules/entities/media';
import { Person } from 'src/app/modules/entities/person';
import { MediaService } from 'src/app/modules/services/media.service';
import { PersonService } from 'src/app/modules/services/person.service';
import { errorDescription, url } from 'src/app/modules/util/constants';
import { environment } from 'src/environments/environment.development';

interface UploadResponse {
  file: File;
  status: string;
  message: string;
  url: string;
}

interface FileExtended {
  objectURL: {
    changingThisBreaksApplicationSecurity: string;
  }
}

@Component({
  selector: 'app-edit-media',
  templateUrl: './edit-media.component.html',
  styleUrls: ['./edit-media.component.css']
})
export class EditMediaComponent implements OnInit {

  constructor(private router: Router, private messageService: MessageService, private mediaService: MediaService, private route: ActivatedRoute,
    private personService: PersonService, private confirmationService: ConfirmationService) {
    const navigation = this.router.getCurrentNavigation();
    this.urlId = this.route.snapshot.paramMap.get('id');
  }

  urlId: string | null;
  files: UploadResponse[] = [];
  selectedFiles: any[] = [];
  message: string = "";
  uploadUrl: string = environment.cfgApiBaseUrl + '/upload';
  uploadLocation: string = environment.cfgApiBaseUrl + '/uploads/';
  thumbnailLocation: string = this.uploadLocation + '/thumbnails/';
  fileReferences: Media[] = [];
  person: Person | undefined;
  showGallery: boolean = false;
  activeIndex: number = 0;
  loading: boolean = false;
  fileLimit: number = 0;

  ngOnInit(): void {
    if (this.urlId) {
      let count: number = 0;
      this.personService.getFullProfile(this.urlId, count).subscribe(response => {
        this.person = response.data as Person;
        this.fileLimit = 20 - this.person?.mediaContent!.length;
      });
    }
  }

  imageClick(index: number): void {
    this.activeIndex = index;
    this.showGallery = true;
  }

  onBeforeUpload() {
    this.loading = true;
  }

  confirm(fileName: string) {
    this.confirmationService.confirm({
        header: 'Confirmación',
        message: 'Realmente desea eliminar la imagen?',
        acceptIcon: 'pi pi-check mr-2',
        rejectIcon: 'pi pi-times mr-2',
        rejectButtonStyleClass: 'p-button-sm',
        acceptButtonStyleClass: 'p-button-outlined p-button-sm',
        acceptLabel: 'Sí',
        rejectLabel: 'No',
        accept: () => {
            this.deleteImage(fileName);
        }
    });
  }

  deleteImage(fileName: string) {
    this.mediaService.deleteImage(fileName, this.person?.url_id).subscribe({
      next: response => {
        if (response.status === 'success') {
          this.ngOnInit();
          this.messageService.add({ severity: 'info', summary: 'Confirmado', detail: 'Imagen eliminada', life: 3000 });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No fue posible eliminar la imagen. Intente nuevamente', life: 3000 });
        }
      },
      error: error => {
        this.messageService.add({severity: 'error', detail: errorDescription[error.error.error]});
        this.router.navigate([url['login']]);
      }
    });
  }

  setAsProfile(fileName: string) {
    this.mediaService.setAsProfile(fileName, this.person?.url_id).subscribe(response => {
      if (response.status === 'success') {
        this.ngOnInit();
        this.messageService.add({ severity: 'info', summary: 'Confirmado', detail: 'Imagen principal modificada', life: 3000 });
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No fue posible modificar la imagen principal. Intente nuevamente', life: 3000 });
      }
    });
  }

  onUpload(event: FileUploadEvent) {
    let i = 0;
    if ((event.originalEvent as HttpResponse<any>).body[i].status === 'success') {
      for (let file of event.files) {
        let message: string = (event.originalEvent as HttpResponse<any>).body[i].status === 'success' 
          ? file.name + ' se cargó correctamente.' 
          : 'Error al cargar el archivo ' + file.name + '. ' + (event.originalEvent as HttpResponse<any>).body[i].message;
        this.files.push({
          file: file,
          status: (event.originalEvent as HttpResponse<any>).body[i].status,
          message: message,
          url: ((file as unknown) as FileExtended).objectURL ? 
            ((file as unknown) as FileExtended).objectURL.changingThisBreaksApplicationSecurity : ''
        });
        this.messageService.add({
          severity: (event.originalEvent as HttpResponse<any>).body[i].status,
          detail: message
        });
        this.fileReferences.push({
          id: undefined,
          fileName: (event.originalEvent as HttpResponse<any>).body[i].data.filename,
          filePath: (event.originalEvent as HttpResponse<any>).body[i].data.filepath,
          type: (event.originalEvent as HttpResponse<any>).body[i].data.type,
          isProfile: 0,
          uploadDate: new Date(Date.parse((event.originalEvent as HttpResponse<any>).body[i].data.uploadDate)),
          order: i + 1,
          visible: 1,
          person: this.person!.url_id,
          views: 0
        });
        i++;
      }
      this.mediaService.saveMediaBulk(this.fileReferences).subscribe(response=> {
        if (response.status === 'success') {
          this.fileReferences = [];
          this.ngOnInit();
        }
      });
    } else {
      this.messageService.add({
        severity: (event.originalEvent as HttpResponse<any>).body[i].status,
        summary: 'Error cargando el archivo.',
        detail: (event.originalEvent as HttpResponse<any>).body[i].message
      });
    }
    this.loading = false;
  }

}
